import MenuSection from "../components/MenuSection";
import { usePortal } from "../lib/portal";

export default function MenuPage() {
  const { data } = usePortal();
  return (
    <div className="pt-[110px]">
      <MenuSection
        categories={data!.menu.categories}
        packages={data!.menu.packages}
        items={data!.menu.items}
        expectedAttendees={data!.event.expectedAttendees}
      />
    </div>
  );
}
